<template>
  <div class="scroller">
    <div class="simplebar-scroll-content" ref="scrollerContent">
      <div class="scroller-content">
        <slot/>
      </div>
    </div>
  </div>
</template>

<script>
  import SimpleBar from 'simplebar';
  import { throttle } from '@Foundation/utilities';
  import { checkScreenSize } from '@Foundation/mixins/checkScreenSize';

  export default {
    name: 'scroller',

    mixins: [checkScreenSize],

    props: {
      setLeft: {
        type: [String, Number, Boolean],
        default: 0
      },
      recalculate: {
        type: [String, Number, Boolean],
        default: 0
      },
      toggleSideContent: {
        type: Boolean,
        default: true
      },
    },

    data() {
      return {
        scrollbar: false,
        scrollElement: null,
        slidesArray: null
      };
    },

    watch: {
      recalculate() {
        this.doRecalculate();
        this.slidesArray = this.$el.querySelectorAll('.scroll-slider__slide');
      },
      setLeft(v) {
        /* istanbul ignore else */
        if (v !== undefined) {
          this.scrollToLeft(v);
        }
      },

      screenSize() {
        this.animatedSlides();
      }
    },

    mounted() {
      this.init();

      this.slidesArray = this.$el.querySelectorAll('.scroll-slider__slide');

      this.animatedSlides();
    },

    methods: {
      hideSideContent() {
        this.hideSlide();
      },

      hideSlide() {
        const sideContent = this.$parent.$el.querySelector('.scroll-slider__side-content').getBoundingClientRect();

        [...this.slidesArray].forEach((slide) => {
          const slideSize = slide.getBoundingClientRect();

          if (slideSize.left < sideContent.left + sideContent.width) {
            slide.classList.add('slide-hidden');
          } else {
            slide.classList.remove('slide-hidden');
          }
        });
      },

      showSlides() {
        [...this.slidesArray].forEach((slide) => {
          slide.setAttribute('style', '');
        });
      },

      scrollHandler() {
        document.dispatchEvent(new CustomEvent('carouselLazyImg'));

        if (this.toggleSideContent && this.screenSize !== 'small') {
          this.hideSideContent();
        }
      },

      /**
       * needs to add trottle
       */
      animatedSlides() {
        this.scrollElement.addEventListener('scroll', throttle(() => {
          this.scrollHandler();
        }, 160));

        if (this.toggleSideContent && this.screenSize !== 'small') {
          this.scrollToLeft(0);
        } else {
          setTimeout(() => {
            window.innerWidth < 1024 && this.showSlides();
            this.scrollToLeft(0);
          }, 100);
        }
      },

      scrollToLeft(pos) {
        pos = typeof pos === 'boolean' ? 0 : parseInt(pos, 10);
        /* istanbul ignore else */
        if (this.scrollbar !== false) {
          this.scrollbar.getScrollElement().scrollLeft = pos;
        }
      },

      doRecalculate() {
        /* istanbul ignore else */
        if (this.scrollbar !== false) {
          this.scrollbar.recalculate();
          this.scrollToLeft(0);
        }
      },

      init() {
        /* istanbul ignore else */
        if (this.scrollbar === false) {
          this.scrollbar = new SimpleBar(this.$refs.scrollerContent, {
            autoHide: false
          });

          this.scrollElement = this.scrollbar.getScrollElement();
        }
      }
    }
  };
</script>
